import React from 'react';
import { withBlockExtensions } from '@plone/volto/helpers';
import { SidebarPortal } from '@plone/volto/components';
import MostVisitedServicesBlockData from './Data';
import MostVisitedServicesBlockView from './View';

const NewsBlockEdit = (props) => {
  const { data, onChangeBlock, block, selected } = props;

  return (
    <>
      <MostVisitedServicesBlockView {...props} isEditMode />
      <SidebarPortal selected={selected}>
        <MostVisitedServicesBlockData data={data} block={block} onChangeBlock={onChangeBlock} />
      </SidebarPortal>
    </>
  );
};

export default withBlockExtensions(NewsBlockEdit);
